import TableLoader from "shared/TableLoader";
import CustomTextField from "components/CustomTextField";
import React, { useState } from "react";
import { Col, Input, Label, Row, Spinner, CardHeader } from "reactstrap";
import Select from "react-select";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import {
  selectCurrentRoles,
  selectCurrentToken,
  selectCurrentUser,
} from "features/auth/authSlice";
import { useSelector } from "react-redux";
import { API_URL } from "app/config";
import { useAllDropDownDataQuery } from "services/dropdownApiSlice";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";

const SaathiEducationDetails = ({ SaathiUserData, SaathiDetailsRefetch }) => {
  const { id } = useParams();
  const [isEdit, setisEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const user_token = useSelector(selectCurrentToken);
  const currentUser = useSelector(selectCurrentUser);
  const RolesFromToken = useSelector(selectCurrentRoles);
  const { handleSubmit, reset } = useForm();
  const { data: dropdownitem } = useAllDropDownDataQuery();

  const [selectedFile, setSelectedFile] = useState();
  const [Qualificationlist, setQualificationlist] = useState("");
  const [selectedQualification, setSelectedQualification] = useState("");
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  function handleQualification(Qualification) {
    setQualificationlist(Qualification);
    setSelectedQualification(Qualification.value);
  }

  const QualificationOptions = () => {
    return dropdownitem?.data?.results[0]?.education?.map((item) => ({
      value: item,
      label: item,
    }));
  };

  const [EducationDetails, editEducationDetails] = useState({
    highest_qualification: selectedQualification,
    year_of_passing: "",
    degree_certificate: "",
  });

  const onInputChange = (event) => {
    editEducationDetails({
      ...EducationDetails,
      [event.target.name]: event.target.value,
    });
  };

  const onSubmitSaathiData = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("degree_certificate", selectedFile);
    formData.append(
      "highest_qualification",
      selectedQualification ||
        SaathiUserData?.education_details?.highest_qualification
    );
    formData.append(
      "year_of_passing",
      EducationDetails?.year_of_passing ||
        SaathiUserData?.education_details?.year_of_passing
    );
    formData.append("applicant_id", id);
    formData.append("created_by", currentUser.sub);
    formData.append("created_by_name", currentUser.name);

    await fetch(`${API_URL}/empanelment/api/education-details/`, {
      method: "POST",
      body: formData,
      redirect: "follow",
      headers: { Authorization: `Bearer ${user_token}` },
    }).then((resp) => {
      const result = resp;
      if (result.status === 200 || result.status === 201) {
        resp
          .json()
          .then((response) => {
            swal("Success", {
              buttons: false,
              icon: "success",
              title: response.message,
              timer: 1500,
            });
            setLoader(false);
            setisEdit(false);
            SaathiDetailsRefetch(id);
          })
          .catch((err) => console.log(err));
      } else {
        result
          .json()
          .then((response) => {
            swal("...Ooops", {
              buttons: false,
              icon: "warning",
              title: response.message,
              timer: 1500,
            });
            setLoader(false);
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 48,
    }),
  };

  return (
    <div style={{ marginTop: "-1%" }}>
      <Row>
        {SaathiUserData === undefined ? (
          <TableLoader />
        ) : (
          <>
            <CardHeader
              style={{ padding: "13px" }}
              className=" mb-3 d-flex justify-content-between align-items-center"
            >
              <h5 className="m-0">Education Details </h5>

              {RolesFromToken.groups?.includes("Maker") ? (
                SaathiUserData?.onboarding_status === "QC1 Approved" ? (
                  ""
                ) : (
                  <div>
                    {" "}
                    {isEdit ? (
                      <Button
                        size="sm"
                        id="editDetails"
                        type=""
                        className=" btn-danger waves-effect  "
                        onClick={() => setisEdit(false)}
                      >
                        Cancel <i className="mdi mdi-window-close"></i>
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        id="editDetails"
                        type=""
                        className="  waves-effect  "
                        onClick={() => setisEdit(true)}
                      >
                        Edit <i className="mdi mdi-file-edit-outline"></i>
                      </Button>
                    )}
                  </div>
                )
              ) : (
                ""
              )}
            </CardHeader>

            <form onSubmit={handleSubmit(onSubmitSaathiData)}>
              <Row>
                <>
                  {isEdit === true ? (
                    <Col lg="3" className="mb-2">
                      <Label className="f_p text_c f_400">
                        Select Highest Qualification{" "}
                        <small className="text-danger">*</small>
                      </Label>
                      <Select
                        value={Qualificationlist}
                        onChange={(e) => handleQualification(e)}
                        options={QualificationOptions()}
                        styles={customStyles}
                        placeholder={
                          SaathiUserData?.education_details
                            ?.highest_qualification || "Select Qualification"
                        }
                      />
                    </Col>
                  ) : (
                    <Col lg="3" className="mb-2">
                      <Label>Highest Qualification</Label>
                      <CustomTextField
                        name=""
                        defaultValue={
                          SaathiUserData?.education_details
                            ?.highest_qualification
                        }
                        disabled
                        placeholder="Select Qualification"
                      />
                    </Col>
                  )}

                  <Col lg="2" className="mb-2">
                    <Label>Year of Passing</Label>
                    <Input
                      name="year_of_passing"
                      defaultValue={
                        SaathiUserData?.education_details?.year_of_passing
                      }
                      disabled={isEdit === true ? false : true}
                      onChange={onInputChange}
                      placeholder="Enter passing Year"
                      className="input_text"
                    />
                  </Col>
                  {isEdit === true ? (
                    <Col lg="4" className="mb-2">
                      <Label className="f_p text_c f_400">
                        Degree Certificate{" "}
                        <small>(Image Or Pdf Format Only*)</small>
                      </Label>
                      <input
                        className="form-control"
                        type="file"
                        name="file"
                        accept="image/*,.pdf"
                        filename="selectedFile"
                        onChange={changeHandler}
                        styles={customStyles}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </>

                {isEdit === true ? (
                  <div className="col-lg-12 text-center m-auto p-2">
                    <button type="submit" className="btn btn-success p-3">
                      <span class="mdi mdi-content-save "></span> Update
                      Education Details &nbsp;
                      {loader ? (
                        <Spinner animation="border" size="sm"></Spinner>
                      ) : (
                        ""
                      )}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </Row>
            </form>
          </>
        )}
      </Row>
    </div>
  );
};

export default SaathiEducationDetails;
